module.exports = __webpack_public_path__ + "static/media/eclipse.fd82f1bb.png";